import { render } from "./ProfileEditView.vue?vue&type=template&id=be9c2746&scoped=true&ts=true"
import script from "./ProfileEditView.vue?vue&type=script&lang=ts"
export * from "./ProfileEditView.vue?vue&type=script&lang=ts"

import "./ProfileEditView.vue?vue&type=style&index=0&id=be9c2746&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9c2746"]])

export default __exports__